import { openQuickBuy } from '../components/quick-buy';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;

  const slides = tile.querySelectorAll('.product-tile__images__img--default');
  if (slides.length > 1) {
    const swiper = new Swiper(
      tile.querySelector('.product-tile__images:not(.no-slider)'),
      {
        direction: 'horizontal',
        slidesPerView: 1,
        loop: true,

        pagination: {
          enabled: true,
          el: tile.querySelector('.product-tile__images__pagination'),
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          enabled: false,
          nextEl: tile.querySelector('.product-tile__images__arrow.right'),
          prevEl: tile.querySelector('.product-tile__images__arrow.left'),
        },
        breakpoints: {
          1024: {
            allowTouchMove: false,
            allowSlideNext: true,
            allowSlidePrev: true,

            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: false,
            },
          },
        },
        on: {
          init(swiper) {
            if (window.innerWidth >= 1024) {
              swiper.slideToLoop(1, 0);
            } else {
              swiper.slideToLoop(0, 0);
            }
          },

          breakpoint(swiper) {
            if (window.innerWidth >= 1024) {
              swiper.slideToLoop(1, 0);
            } else {
              swiper.slideToLoop(0, 0);
            }
          },
        },
      },
    );
  }

  if (!tile?.dataset?.drawerUrl) return;
  const hoverOpener = tile.querySelector(
    '.product-tile__absolutes__form-opener',
  );
  if (hoverOpener) {
    hoverOpener.addEventListener('click', (e) => {
      e.preventDefault();
      openQuickBuy(tile.dataset.drawerUrl);
    });
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.product-tile__container'),
    (tile) => {
      window.dAgency.initProductTile(tile);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.product-tile__container'),
      (tile) => {
        window.dAgency.initProductTile(tile);
      },
    );
  });
}
